import { render, staticRenderFns } from "./CreateSequenceFormDetails.vue?vue&type=template&id=637e58a6&"
import script from "./CreateSequenceFormDetails.vue?vue&type=script&lang=ts&"
export * from "./CreateSequenceFormDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports